import React from 'react';
export const Myfancyworld = ({currentpage,setcurrentpage}) => {
  if (currentpage==="/My_fancy_world"){
	  return (
		<div>
			<h1>My fancy world</h1>
		</div>
	  );
  }
};